import styled from 'styled-components';
import { Title as TitleComponent, Check, Text } from '~components';

export const Container = styled.main`
  height: 100%;
  display: flex;
  flex-direction: column;
  margin-top: ${({ theme }) => theme.spacing.km16};
`;

export const Title = styled(TitleComponent)`
  color: ${({ theme }) => theme.color.text.neutral.strong};
  font-weight: ${({ theme }) => theme.font.weight.bold};
  font-size: ${({ theme }) => theme.font.size.m5};
  margin: ${({ theme }) => `${theme.spacing.km6} ${theme.spacing.km0}`};
`;

export const Block = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
`;

export const LegendText = styled(Text)`
  margin-top: ${({ theme }) => theme.spacing.km8};
`;

export const EmptyFooter = styled.footer`
  display: flex;
  justify-content: center;
  align-items: center;

  border-top: 1px solid ${({ theme }) => theme.color.border.neutral.default};
  margin: 0 -${({ theme }) => theme.spacing.km6};
  margin-top: auto;
  margin-bottom: -${({ theme }) => theme.spacing.km6};
  min-height: 80px;
`;

export const CheckIcon = styled(Check)`
  display: inline-block;
  color: ${({ theme }) => theme.color.icon.success.default};
`;
